import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const ProtectedRoute = ({ children }) => {
  const { userToken, user, isLoading } = useSelector((state) => state.auth);

  if (isLoading) {
    return <div>Loading user data...</div>;
  }

  if (!userToken || !user) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;

